import { backendDateOrDateTimeToLuxonDateTime } from "../../utils/dates/backendDateOrDateTimeToLuxonDateTime";

interface DateRangeInterface {
  beginDate?: string;
  endDate?: string;
}

function getDateRange({ beginDate, endDate }: DateRangeInterface) {
  if (!beginDate || !endDate) {
    return "";
  }

  const begin = backendDateOrDateTimeToLuxonDateTime(beginDate);
  const end = backendDateOrDateTimeToLuxonDateTime(endDate);

  const month = begin.hasSame(end, "month") && begin.hasSame(end, "year");
  const year = begin.hasSame(end, "year");

  if (month) {
    return begin.toLocaleString({ month: "short", year: "numeric" });
  } else if (year) {
    return begin.toLocaleString({ year: "numeric" });
  } else {
    return `${begin.toLocaleString({ month: "short", year: "numeric" })} - ${end.toLocaleString({ month: "short", year: "numeric" })}`;
  }
}

export { getDateRange };
